import { load } from '@cashfreepayments/cashfree-js';

let cashfreePromise = initializeSDK();

async function initializeSDK() {          
    try {
        const cashfree = await load({
            // mode: "production"
            mode: "sandbox"
        });
        return cashfree;
    } catch (error) {
        console.error('Failed to initialize Cashfree SDK:', error);
        throw error; // Propagate the error if initialization fails
    }
}

export default cashfreePromise;